import {omneticApi} from '@dms/api/base';

import {
  CreateSourcingCebiaReportApiArg,
  CreateSourcingCebiaReportApiResponse,
  GetSourcingCebiaReportApiArg,
  GetSourcingCebiaReportApiResponse,
  GetSourcingCebiaReportStatusesApiArg,
  GetSourcingCebiaReportStatusesApiResponse,
  RegenerateSourcingCebiaReportApiArg,
  RegenerateSourcingCebiaReportApiResponse,
} from './types';

export const sourcingCebiaReportApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getSourcingCebiaReport: build.query<
      GetSourcingCebiaReportApiResponse,
      GetSourcingCebiaReportApiArg
    >({
      query: ({externalId}) => ({
        url: `/dms/v1/sourcing-vehicle/${encodeURIComponent(externalId)}/autotracer-pl-report`,
      }),
      providesTags: (_result, _error, {externalId}) => [
        {type: 'AutotracerPlReport', id: externalId},
      ],
    }),
    getSourcingCebiaReportStatuses: build.query<
      GetSourcingCebiaReportStatusesApiResponse,
      GetSourcingCebiaReportStatusesApiArg
    >({
      query: ({externalIds}) => ({
        url: '/dms/v1/sourcing-vehicle/autotracer-pl-report/status',
        method: 'POST',
        body: {externalIds},
      }),
      providesTags: [{type: 'AutotracerPlReport', id: 'LIST'}],
    }),
    // Both mutations refetch on errors: a paid request may succeed server-side before its response is lost.
    createSourcingCebiaReport: build.mutation<
      CreateSourcingCebiaReportApiResponse,
      CreateSourcingCebiaReportApiArg
    >({
      query: ({externalId}) => ({
        url: `/dms/v1/sourcing-vehicle/${encodeURIComponent(externalId)}/autotracer-pl-report`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, {externalId}) => [
        {type: 'AutotracerPlReport', id: externalId},
        {type: 'AutotracerPlReport', id: 'LIST'},
      ],
    }),
    regenerateSourcingCebiaReport: build.mutation<
      RegenerateSourcingCebiaReportApiResponse,
      RegenerateSourcingCebiaReportApiArg
    >({
      query: ({externalId, requestId}) => ({
        url: `/dms/v1/sourcing-vehicle/${encodeURIComponent(externalId)}/autotracer-pl-report/regenerate`,
        method: 'POST',
        body: {requestId},
      }),
      invalidatesTags: (_result, _error, {externalId}) => [
        {type: 'AutotracerPlReport', id: externalId},
        {type: 'AutotracerPlReport', id: 'LIST'},
      ],
    }),
  }),
});

export const {
  useGetSourcingCebiaReportQuery,
  useLazyGetSourcingCebiaReportQuery,
  useGetSourcingCebiaReportStatusesQuery,
  useCreateSourcingCebiaReportMutation,
  useRegenerateSourcingCebiaReportMutation,
} = sourcingCebiaReportApi;
